// react
import { useContext } from 'react';

// context
import { ContextAdvances } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableAdvances } from '../../../../tables/cards/TableAdvances/TableAdvances';

export const Advances = () => {
	// context
	const { advances, isLoadingAdvances, paginationAdvances, refetchAdvances } =
		useContext(ContextAdvances);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableAdvances
						isLoading={isLoadingAdvances}
						pagination={paginationAdvances}
						refetchTransactions={refetchAdvances}
						transactions={advances}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
